<section>

    <div class="page page-dashboard">

        <div class="pageheader">
            <h2>{{language?.dashboard.dashboard | titlecase}}</h2>
        </div>

        <!-- page content -->
        <div class="pagecontent">

            <!-- row -->
            <div class="row">
                <div class="col-md-12">
                    <div class="tile tile-simple">

                        <!-- tile body -->
                        <div class="tile-body">
                            <div role="tabpanel">

                                <!-- Nav tabs -->
                                <ul class="nav nav-tabs tabs-dark" role="tablist">
                                    <li role="presentation" class="active"><a href="#dashboard" aria-controls="feedTab"
                                            role="tab" data-toggle="tab">{{language?.dashboard.dashboard }}</a></li>
                                    <li role="presentation"><a href="#maintenanceTab" aria-controls="maintenanceTab"
                                            role="tab" data-toggle="tab">{{language?.dashboard.calendar}} </a></li>
                                </ul>


                                <div class="tab-content">

                                    <div role="tabpanel" class="tab-pane active" id="dashboard">
                                        <!-- cards row -->
                                        <div class="row cmn-height">
                                            <!-- col -->
                                            <div class="card-container col-lg-3 col-sm-6 col-sm-12"
                                                *ngxPermissionsOnly="AppPermissions.DEADLINE">
                                                <div class="card">
                                                    <div class="front bg-greensea">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="fa fa-bomb fa-3x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">
                                                                    {{language?.general.deadline | titlecase}}</p>
                                                                <span><span
                                                                        class="no-strong">{{dashboardData?.deadline?.total}}</span>
                                                                    {{language?.dashboard.deadlineText |
                                                                    titlecase}}</span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                    <div class="back bg-greensea">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a [routerLink]="['/'+AppFrontRoutes.Deadline_List]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /col -->

                                            <!-- col -->
                                            <div class="card-container col-lg-3 col-sm-6 col-sm-12"
                                                *ngxPermissionsOnly="AppPermissions.SERVICING">
                                                <div class="card">
                                                    <div class="front bg-lightred">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="fa fa-wrench fa-3x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">
                                                                    {{language?.general.servicing | titlecase}}</p>
                                                                <span><span
                                                                        class="no-strong">{{dashboardData?.servicing?.total}}</span>
                                                                    {{language?.dashboard.servicingText |
                                                                    titlecase}}</span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>

                                                    <div class="back bg-lightred">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a [routerLink]="['/'+AppFrontRoutes.Servicing_List]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /col -->

                                            <!-- col -->
                                            <div class="card-container col-lg-3 col-sm-6 col-sm-12"
                                                *ngxPermissionsOnly="AppPermissions.HUMAN_RESOURCE">
                                                <div class="card">
                                                    <div class="front bg-blue">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="fa fa-group fa-3x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">
                                                                    {{language?.general.humanResources | titlecase}}</p>
                                                                <span><span
                                                                        class="no-strong">{{dashboardData?.human_resource?.total}}</span>
                                                                    {{language?.dashboard.humanResourcesText |
                                                                    titlecase}}</span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                    <div class="back bg-blue">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a [routerLink]="['/'+AppFrontRoutes.EMPLOYEE_LIST]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /col -->

                                            <!-- col -->
                                            <div class="card-container col-lg-3 col-sm-6 col-sm-12"
                                                *ngxPermissionsOnly="AppPermissions.MEASUREMENT_TOOL">
                                                <div class="card">
                                                    <div class="front bg-slategray">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="glyphicon glyphicon-screenshot fa-3x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">
                                                                    {{language?.general.measurementTools | titlecase}}
                                                                </p>
                                                                <span><span
                                                                        class="no-strong">{{dashboardData?.mesurement_tool?.total}}</span>
                                                                    {{language?.dashboard.measurementToolsText |
                                                                    titlecase}}</span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                    <div class="back bg-slategray">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a [routerLink]="['/'+AppFrontRoutes.MEASUREMENT]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /col -->

                                            <!-- col -->
                                            <div class="card-container col-lg-3 col-sm-6 col-sm-12"
                                                *ngxPermissionsOnly="AppPermissions.PROBLEM_SOLVING">
                                                <div class="card">
                                                    <div class="front bg-orange">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="glyphicon glyphicon-question-sign fa-3x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">
                                                                    {{language?.general.problemSolving | titlecase}}</p>
                                                                <span><span
                                                                        class="no-strong">{{dashboardData?.problem_solving?.total}}</span>
                                                                    {{language?.dashboard.problemSolvingText |
                                                                    titlecase}}</span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                    <div class="back bg-orange">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a [routerLink]="['/'+AppFrontRoutes.PROBLEM_SOLVING]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /col -->

                                            <!-- col -->
                                            <div class="card-container col-lg-3 col-sm-6 col-sm-12"
                                                *ngxPermissionsOnly="AppPermissions.DOCUMENT_MANAGEMENT">
                                                <div class="card">
                                                    <div class="front bg-amethyst">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="fa fa-folder-open fa-3x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">
                                                                    {{language?.general.documentMang | titlecase}}</p>
                                                                <span><span
                                                                        class="no-strong">{{dashboardData?.doc_management?.total}}</span>
                                                                    {{language?.dashboard.documentMangText |
                                                                    titlecase}}</span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                    <div class="back bg-amethyst">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a
                                                                    [routerLink]="['/'+AppFrontRoutes.DOCUMENT_MANAGEMENT]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /col -->

                                            <!-- col -->
                                            <div class="card-container col-lg-3 col-sm-6 col-sm-12"
                                                *ngxPermissionsOnly="AppPermissions.CUSTOMERS">
                                                <div class="card">
                                                    <div class="front bg-dutch">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="glyphicon glyphicon-shopping-cart fa-3x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">
                                                                    {{language?.general.customers | titlecase}}</p>
                                                                <span><span
                                                                        class="no-strong">{{dashboardData?.clients?.total}}</span>
                                                                    {{language?.dashboard.customersText |
                                                                    titlecase}}</span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                    <div class="back bg-dutch">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a [routerLink]="['/'+AppFrontRoutes.CUSTOMERS]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /col -->

                                            <!-- col -->
                                            <div class="card-container col-lg-3 col-sm-6 col-sm-12"
                                                *ngxPermissionsOnly="AppPermissions.CONSULTANCY">
                                                <div class="card">
                                                    <div class="front bg-cyan">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="glyphicon glyphicon-retweet fa-3x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">
                                                                    {{language?.general.consultancy | titlecase}}</p>
                                                                <span><span
                                                                        class="no-strong">{{dashboardData?.consultancy?.total}}</span>
                                                                    {{language?.dashboard.consultancyText |
                                                                    titlecase}}</span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                    <div class="back bg-cyan">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a [routerLink]="['/'+AppFrontRoutes.CONSULTANCY]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /col -->

                                            <!-- col -->
                                            <div class="card-container col-lg-3 col-sm-6 col-sm-12"
                                                *ngxPermissionsOnly="AppPermissions.ACADEMY">
                                                <div class="card">
                                                    <div class="front bg-hotpink">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="fa fa-graduation-cap fa-3x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">
                                                                    {{language?.general.academy
                                                                    | titlecase}}</p>
                                                                <span><span
                                                                        class="no-strong">{{dashboardData?.academy?.total}}</span>
                                                                    {{language?.dashboard.academyText |
                                                                    titlecase}}</span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                    <div class="back bg-hotpink">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a [routerLink]="['/'+AppFrontRoutes.SCHEDULEDCOURSES]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /col -->

                                            <!-- col -->
                                            <div class="card-container col-lg-3 col-sm-6 col-sm-12"
                                                *ngxPermissionsOnly="AppPermissions.PROJECT">
                                                <div class="card">
                                                    <div class="front bg-drank">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="fa fa-pencil fa-3x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">
                                                                    {{language?.general.project
                                                                    | titlecase}}</p>
                                                                <span><span
                                                                        class="no-strong">{{dashboardData?.project?.total}}</span>
                                                                    {{language?.dashboard.projectText |
                                                                    titlecase}}</span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                    <div class="back bg-drank">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a [routerLink]="['/'+AppFrontRoutes.PROJECT]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /col -->

                                            <!-- col -->
                                            <div class="card-container col-lg-3 col-sm-6 col-sm-12"
                                                *ngxPermissionsOnly="AppPermissions.AUDIT">
                                                <div class="card">
                                                    <div class="front bg-blue">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-4">
                                                                <i class="fa fa-eye fa-3x"></i>
                                                            </div>
                                                            <!-- /col -->
                                                            <!-- col -->
                                                            <div class="col-xs-8 no-padding-left">
                                                                <p class="text-elg text-strong mb-0">
                                                                    {{language?.general.audit |
                                                                    titlecase}}</p>
                                                                <span><span class="no-strong">0</span>
                                                                    {{language?.dashboard.auditText | titlecase}}</span>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                    <div class="back bg-blue">

                                                        <!-- row -->
                                                        <div class="row">
                                                            <!-- col -->
                                                            <div class="col-xs-12">
                                                                <a [routerLink]="['/'+AppFrontRoutes.AUDIT_LIST]"><i
                                                                        class="fa fa-ellipsis-h fa-2x"></i> More</a>
                                                            </div>
                                                            <!-- /col -->
                                                        </div>
                                                        <!-- /row -->

                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /col -->



                                        </div>
                                        <!-- /row -->
                                    </div>


                                    <div role="tabpanel" class="tab-pane" id="maintenanceTab">
                                        <div class="row">
                                        <!-- <div class="col-md-2">
                                        </div> -->
                                        <div class="col-md-12">
                                        <!-- <app-dashboard-calendar></app-dashboard-calendar> -->
                                        <app-calendar></app-calendar>
                                    </div>
                                </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>


</section>